import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';
import {CycledActDecorator} from './decorators/CycledActDecorator';

/**
 * AsyncAct class is used only with AsyncActDecorator.
 */
export class CycledAct extends Act {
    private _decoratorAct?: CycledActDecorator;

    protected async executeInternal(): Promise<void> {
        if (this._decoratorAct) {
            consoleLogger.log('>>>>CycledAct started: ', this._decoratorAct.getName());
            await this.executeCycle();
            consoleLogger.log('>>>>CycledAct finished: ', this._decoratorAct.getName());
        }
    }

    protected async executeCycle(): Promise<void> {
        if (this._decoratorAct?.cycleCondition()) {
            this._decoratorAct.setAct();
            await new Promise(res => this._decoratorAct!.act?.execute(() => res(undefined)));
            await this.executeCycle();
            this.disposeDecoratorAct();
        }
    }

    public async skip(): Promise<void> {
        await this._decoratorAct?.act?.skip();
        this.onExecuted?.();
    }

    public async forceSkip(): Promise<void> {
        await this._decoratorAct?.act?.forceSkip();
    }

    public set decoratorAct(value: CycledActDecorator) {
        this._decoratorAct = value;
    }

    public dispose(): void {
        super.dispose();
        this.disposeDecoratorAct();
    }

    protected disposeDecoratorAct(): void {
        if (this._decoratorAct?.act) {
            this._decoratorAct.act.dispose();
            this._decoratorAct.act = undefined;
        }
    }
}